// Manager PTO review queue. Approve / deny / leave note.

import { useEffect, useState } from 'react';
import { api } from '../../api';

export default function PtoReviewPage() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState('pending');
  const [notes, setNotes] = useState({});

  function load() { api.listPtoRequests(filter).then(setRows).catch(() => setRows([])); }
  useEffect(load, [filter]);

  async function approve(id) {
    try { await api.approvePto(id, notes[id] || null); load(); } catch (e) { alert(e.message); }
  }
  async function deny(id) {
    try { await api.denyPto(id, notes[id] || 'Denied'); load(); } catch (e) { alert(e.message); }
  }

  return (
    <div className="page">
      <div className="page-header">
        <h2>PTO Requests</h2>
        <div className="filter-bar">
          <select value={filter} onChange={e => setFilter(e.target.value)}>
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="denied">Denied</option>
            <option value="">All</option>
          </select>
        </div>
      </div>
      <table className="data-table">
        <thead><tr><th>Employee</th><th>Type</th><th>Dates</th><th>Hours</th><th>Status</th><th>Manager Notes</th><th></th></tr></thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id}>
              <td>{r.full_name}</td>
              <td>{r.request_type}</td>
              <td>{r.start_date} → {r.end_date}</td>
              <td>{r.hours_requested}</td>
              <td><span className={`status-pill status-${r.status}`}>{r.status}</span></td>
              <td>
                {r.status === 'pending'
                  ? <input value={notes[r.id] || ''} onChange={e => setNotes(x => ({...x, [r.id]: e.target.value}))} />
                  : <span className="muted">{r.manager_notes}</span>}
              </td>
              <td>
                {r.status === 'pending' && (
                  <>
                    <button className="btn-primary" onClick={() => approve(r.id)}>Approve</button>
                    <button className="btn-secondary" onClick={() => deny(r.id)}>Deny</button>
                  </>
                )}
              </td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan="7" className="empty">No requests.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
